/**
 * mtc-backoffice-api
 * MTC Backoffice Composite Api
 *
 * OpenAPI spec version: 0.1.0-SNAPSHOT
 * Contact: developers@greysystems.eu
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


export interface IdentityDocument { 
    countryDelivery?: string;
    dateDelivery?: Date;
    dateExpiration?: Date;
    dateImageInsertion?: Date;
    documentNumber?: string;
    fullImagePath?: string;
    type?: IdentityDocument.TypeEnum;
}
export namespace IdentityDocument {
    export type TypeEnum = 'PASS' | 'DRVL' | 'EICD' | 'NEIC' | 'OTHR' | 'NICD' | 'RECD' | 'GVID' | 'STID' | 'GUNL' | 'DIPL' | 'CMPI' | 'IPOC' | 'CRLT' | 'CRSV' | 'CRLV' | 'CDRB' | 'LRPT' | 'EDRL' | 'RSVS' | 'BRDP' | 'CPFI' | 'NIFI' | 'LICI' | 'LIEN' | 'CEID';
    export const TypeEnum = {
        PASS: 'PASS' as TypeEnum,
        DRVL: 'DRVL' as TypeEnum,
        EICD: 'EICD' as TypeEnum,
        NEIC: 'NEIC' as TypeEnum,
        OTHR: 'OTHR' as TypeEnum,
        NICD: 'NICD' as TypeEnum,
        RECD: 'RECD' as TypeEnum,
        GVID: 'GVID' as TypeEnum,
        STID: 'STID' as TypeEnum,
        GUNL: 'GUNL' as TypeEnum,
        DIPL: 'DIPL' as TypeEnum,
        CMPI: 'CMPI' as TypeEnum,
        IPOC: 'IPOC' as TypeEnum,
        CRLT: 'CRLT' as TypeEnum,
        CRSV: 'CRSV' as TypeEnum,
        CRLV: 'CRLV' as TypeEnum,
        CDRB: 'CDRB' as TypeEnum,
        LRPT: 'LRPT' as TypeEnum,
        EDRL: 'EDRL' as TypeEnum,
        RSVS: 'RSVS' as TypeEnum,
        BRDP: 'BRDP' as TypeEnum,
        CPFI: 'CPFI' as TypeEnum,
        NIFI: 'NIFI' as TypeEnum,
        LICI: 'LICI' as TypeEnum,
        LIEN: 'LIEN' as TypeEnum,
        CEID: 'CEID' as TypeEnum
    };
}
